{
  "common": {
    "ok": "OK",
    "cancel": "Annulla",
    "save": "Salva",
    "delete": "Elimina",
    "edit": "Modifica",
    "close": "Chiudi",
    "loading": "Caricamento...",
    "error": "Errore",
    "info": "Informazione",
    "success": "Successo",
    "back": "Indietro",
    "send": "Invia",
    "sending": "Invio...",
    "search": "Cerca",
    "accept": "Accetta",
    "reject": "Rifiuta",
    "confirm": "Conferma",
    "online": "Online",
    "you": "Tu",
    "noMessages": "Nessun messaggio ancora",
    "adminPanelDesktopOnly": "Pannello non disponibile sul telefono",
    "adminPanelDesktopOnlyHint": "I pannelli admin e organizzatore sono disponibili su tablet e desktop.",
    "networkError": "Impossibile caricare i dati.",
    "networkErrorHint": "Controlla la connessione e riprova.",
    "retry": "Riprova",
    "myQrCode": "Il mio codice QR",
    "myQrPill": "Il mio QR",
    "hideQrPill": "Nascondi il mio QR",
    "showQrPill": "Mostra il mio QR",
    "today": "Oggi",
    "tomorrow": "Domani"
  },
  "auth": {
    "login": {
      "title": "Bentornato",
      "subtitle": "Accedi",
      "credentialsHint": "Inserisci le tue credenziali per continuare",
      "email": "Email",
      "emailPlaceholder": "tu@email.com",
      "password": "Password",
      "passwordPlaceholder": "••••••••",
      "loading": "Accesso in corso...",
      "button": "Accedi",
      "forgotPassword": "Hai dimenticato la password?",
      "forgotPasswordSoon": "Prossimamente",
      "forgotPasswordMessage": "Il recupero della password sarà disponibile presto.",
      "continueWith": "o continua con",
      "noAccount": "Non hai un account?",
      "createAccount": "Crea account",
      "errors": {
        "emailNotConfirmed": "Non siamo riusciti ad accedere.\n\nSe hai appena creato l’account, riprova tra qualche secondo.",
        "loginError": "Errore di accesso",
        "unexpectedError": "Si è verificato un errore imprevisto. Per favore, riprova."
      }
    },
    "register": {
      "title": "Unisciti a BIAVENT",
      "subtitle": "Crea Account",
      "email": "Email",
      "emailPlaceholder": "tu@email.com",
      "password": "Password",
      "confirmPassword": "Conferma Password",
      "loading": "Creazione account...",
      "button": "Crea Account",
      "continueWith": "o continua con",
      "hasAccount": "Hai già un account?",
      "loginLink": "Accedi",
      "success": {
        "title": "✅ Account creato con successo!",
        "message": "Ora puoi accedere. Completiamo il tuo profilo."
      },
      "errors": {
        "createError": "Errore nella creazione dell'account",
        "unexpectedError": "Errore imprevisto"
      }
    },
    "logout": {
      "button": "Esci",
      "confirm": "Sei sicuro di voler uscire?"
    },
    "forgotPassword": {
      "title": "Recupero password",
      "subtitle": "Reimposta la password",
      "description": "Inserisci la tua email e ti invieremo un link per reimpostare la password.",
      "email": "Email",
      "emailPlaceholder": "tua@email.com",
      "loading": "Invio in corso...",
      "button": "Invia link",
      "backToLogin": "Torna all'accesso",
      "success": {
        "title": "Controlla la tua email",
        "message": "Se esiste un account con quell'email, riceverai un link per reimpostare la password."
      },
      "errors": {
        "unexpectedError": "Si è verificato un errore imprevisto. Riprova."
      }
    },
    "resetPassword": {
      "title": "Nuova password",
      "subtitle": "Scegli una nuova password",
      "description": "Inserisci e conferma la nuova password.",
      "password": "Nuova password",
      "passwordPlaceholder": "••••••••",
      "confirmPassword": "Conferma password",
      "confirmPasswordPlaceholder": "••••••••",
      "loading": "Aggiornamento...",
      "button": "Aggiorna password",
      "backToLogin": "Torna all'accesso",
      "requirements": {
        "minLength": "Almeno 8 caratteri",
        "lowercase": "Almeno una minuscola",
        "uppercase": "Almeno una maiuscola",
        "number": "Almeno un numero",
        "symbol": "Almeno un simbolo"
      },
      "success": {
        "title": "Password aggiornata",
        "message": "La tua password è stata aggiornata con successo."
      },
      "invalidLink": {
        "title": "Link non valido o scaduto",
        "message": "Questo link di recupero non è valido o è scaduto. Richiedine uno nuovo.",
        "cta": "Richiedi nuovo link"
      },
      "errors": {
        "unexpectedError": "Si è verificato un errore imprevisto. Riprova."
      }
    }
  },
  "onboarding": {
    "personalInfo": {
      "title": "Informazioni personali",
      "subtitle": "Completa il tuo profilo base",
      "firstName": "Nome",
      "lastName": "Cognome",
      "phone": "Telefono",
      "email": "Email",
      "placeholderFirstName": "Il tuo nome",
      "placeholderLastName": "Il tuo cognome",
      "placeholderPhone": "+34 600 000 000",
      "placeholderEmail": "tuo@email.com",
      "continue": "Continua",
      "errorFirstName": "Il nome è obbligatorio",
      "errorLastName": "Il cognome è obbligatorio",
      "errorPhone": "Inserisci un numero di telefono valido",
      "errorEmail": "Inserisci un'email valida"
    },
    "socialNetworks": {
      "title": "Social Network (Scegline uno o più)",
      "linkedin": "LinkedIn",
      "instagram": "Instagram",
      "twitter": "X (Twitter)",
      "youtube": "YouTube",
      "tiktok": "TikTok",
      "placeholderLinkedin": "https://linkedin.com/in/tuo-profilo",
      "placeholderInstagram": "https://instagram.com/tuo-utente",
      "placeholderTwitter": "https://twitter.com/tuo-utente",
      "placeholderYoutube": "https://youtube.com/@tuo-canale",
      "placeholderTiktok": "https://tiktok.com/@tuo-utente",
      "errorInvalid": "Inserisci un URL valido"
    },
    "welcomeQuestion": {
      "title": "A cosa ti dedichi?",
      "subtitle": "La tua risposta ci aiuterà a generare parole chiave per il networking e a suggerirti connessioni rilevanti durante l'evento.",
      "placeholder": "Es: Sono uno sviluppatore frontend, lavoro nel marketing digitale, sono un imprenditore...",
      "continue": "Continua",
      "back": "Indietro",
      "loading": "Elaborazione...",
      "error": "Non siamo riusciti a elaborare la tua risposta. Riprova.",
      "errorEmpty": "Scrivi qualcosa su di te per continuare"
    }
  },
  "appTour": {
    "replayButton": "Vedi di nuovo il tutorial",
    "welcome": {
      "title": "Benvenuto su Biavent!",
      "subtitle": "Un breve tour per iniziare con sicurezza.",
      "start": "Inizia il tour",
      "skip": "Salta per ora"
    },
    "controls": {
      "prev": "Indietro",
      "next": "Avanti",
      "skip": "Salta tutorial",
      "close": "Chiudi",
      "done": "Fine",
      "progress": "{{current}} di {{total}}",
      "tapHere": "Tocca qui"
    },
    "steps": {
      "navOverview": {
        "title": "Navigazione",
        "body": "Da qui accedi alle sezioni principali dell'app."
      },
      "eventsHome": {
        "title": "I tuoi eventi",
        "body": "Vedi i prossimi eventi e il tuo benvenuto personalizzato."
      },
      "eventsDiscover": {
        "title": "Esplora eventi",
        "body": "Qui compaiono tutti gli eventi."
      },
      "navNetworking": {
        "title": "Networking",
        "body": "Tocca qui per andare a connessioni e chat."
      },
      "networkingHub": {
        "title": "Attività e connessioni",
        "body": "Gestisci richieste, contatti e conversazioni."
      },
      "navProfile": {
        "title": "Il tuo profilo",
        "body": "Tocca per vedere e modificare il tuo profilo professionale."
      },
      "profileComplete": {
        "title": "Profilo completo",
        "body": "Più completi il tuo profilo, migliori raccomandazioni possiamo offrirti."
      },
      "qrEssential": {
        "title": "Il tuo codice QR",
        "body": "Mostra il QR agli eventi per connetterti subito."
      }
    }
  },
  "admin": {
    "title": "Administración",
    "eventos": "Eventos",
    "usuarios": "Usuarios",
    "organizaciones": "Aziende",
    "permisos": "Permisos",
    "rankings": "Rankings",
    "encuentros": "Incontri",
    "informes": "Informes y Métricas",
    "notificaciones": "Notificaciones",
    "dashboard": "Dashboard",
    "dashboardTitle": "Dashboard",
    "dashboardSubtitle": "Panoramica della piattaforma",
    "dashboardKpiEvents": "Eventi totali",
    "dashboardKpiUsers": "Utenti totali",
    "dashboardKpiOrganizations": "Aziende",
    "dashboardKpiUpcoming": "Eventi in programma",
    "dashboardKpiPublished": "Pubblicati",
    "dashboardKpiDraft": "Bozze",
    "dashboardKpiPast": "Terminati",
    "dashboardKpiCancelled": "Annullati",
    "dashboardUpcomingEvents": "Eventi in programma",
    "dashboardQuickActions": "Azioni rapide",
    "dashboardViewEvents": "Vedi eventi",
    "dashboardViewUsers": "Vedi utenti",
    "dashboardViewOrganizations": "Vedi aziende",
    "dashboardViewReports": "Vedi report",
    "dashboardViewNotifications": "Vedi notifiche",
    "dashboardNewEvent": "Nuovo evento",
    "dashboardNoUpcoming": "Nessun evento in programma",
    "dashboardEventDate": "Data",
    "dashboardLoading": "Caricamento panoramica...",
    "nuevoEvento": "Nuevo Evento",
    "organizacionesTitle": "Organizaciones",
    "organizacionesSubtitle": "Gestiona las organizaciones de la plataforma",
    "permisosTitle": "Permisos de organizador",
    "permisosSubtitle": "Asigna o quita el rol de organizador y asocia usuarios a organizaciones",
    "crearOrganizacion": "Crear organización",
    "crearOrganizacionHint": "La organización se creará con tu usuario como propietario y organizador.",
    "asignarOrganizador": "Asignar como organizador",
    "seleccionarOrganizacion": "Seleziona azienda",
    "sinOrganizacionesPermisos": "Crea un'azienda nella scheda Aziende per poter assegnare.",
    "quitarOrganizador": "Quitar rol organizador",
    "asociarAOrganizacion": "Asociar a organización",
    "nombreOrganizacion": "Nombre",
    "miembros": "Miembros",
    "propietario": "Propietario",
    "sinOrganizaciones": "Nessuna azienda",
    "gestionarPermisos": "Gestisci permessi",
    "gestionarEquipo": "Gestisci team",
    "equipoTitle": "Team di «{name}»",
    "equipoDescription": "Aggiungi utenti a questa azienda. Ogni utente può appartenere a una sola azienda.",
    "equipoEmpty": "Nessun membro in questa azienda",
    "equipoSelectUser": "Seleziona utente",
    "equipoSearchUser": "Cerca per nome o email…",
    "equipoSearchMin": "Digita almeno 2 caratteri",
    "equipoSearchEmpty": "Nessun utente trovato",
    "equipoClearSelection": "Rimuovi selezione",
    "equipoAdd": "Aggiungi al team",
    "rolOrganizador": "Organizzatore",
    "rolMiembro": "Membro",
    "quitarMiembro": "Rimuovi",
    "panelScreens": "Schermate del panel",
    "panelScreensTitle": "Schermate visibili nel panel organizzatore",
    "panelScreensDescription": "Attiva o disattiva le sezioni che gli organizzatori di questa azienda vedranno.",
    "panelScreenDashboard": "Dashboard",
    "panelScreenEvents": "Eventi",
    "panelScreenAttendees": "Partecipanti",
    "panelScreenNetworking": "Networking",
    "panelScreenAnalytics": "Analytics",
    "panelScreenNotifications": "Notifiche",
    "panelScreenSettings": "Impostazioni organizzazione",
    "eliminarEmpresa": "Elimina azienda",
    "confirmarEliminarEmpresa": "Elimina azienda",
    "confirmarEliminarEmpresaHint": "Eliminare l'azienda «{name}»? I membri saranno rimossi e gli eventi non avranno azienda assegnata.",
    "panelScreensSave": "Salva schermate",
    "panelScreensAll": "Tutte",
    "eventosSubtitle": "Gestisci tutti gli eventi della piattaforma",
    "usuariosSubtitle": "Gestisci utenti e permessi",
    "rankingsSubtitle": "Classifiche utenti per connessioni e attività",
    "encuentrosSubtitle": "Incontri di persona confermati via QR tra utenti connessi",
    "meetups": {
      "loading": "Caricamento incontri…",
      "kpiTotal": "Totale confermati",
      "kpi24h": "Ultime 24 ore",
      "kpi7d": "Ultimi 7 giorni",
      "searchPlaceholder": "Cerca per nome o email…",
      "empty": "Nessun incontro confermato via QR",
      "emptyHint": "Quando due utenti confermano un incontro di persona, apparirà qui.",
      "noSearchResults": "Nessun risultato",
      "noSearchResultsHint": "Prova con un altro nome o email.",
      "colUserA": "Utente A",
      "colUserB": "Utente B",
      "colDate": "Data",
      "colMethod": "Metodo",
      "methodQr": "QR",
      "methodUnknown": "—"
    },
    "informesSubtitle": "Metriche in tempo reale per eventi futuri e report completi per quelli passati",
    "notificacionesSubtitle": "Invia notifiche a tutti gli utenti o a utenti selezionati",
    "filterOptions": "Opzioni di filtro",
    "filterAll": "Tutti",
    "filterUpcoming": "Prossimi",
    "filterPast": "Passati",
    "filterCancelled": "Annullati",
    "filterAdmins": "Amministratori",
    "filterUsers": "Utenti",
    "rankingByConnections": "Per connessioni totali",
    "rankingMostConnected": "Più connessi",
    "rankingByConnectionsTitle": "Classifica per connessioni",
    "rankingMostConnectedTitle": "Utenti più connessi",
    "rankingType": "Tipo di classifica",
    "tableTitle": "Titolo",
    "tableDate": "Data",
    "tableLocation": "Luogo",
    "tableStatus": "Stato",
    "tableActions": "Azioni",
    "tableName": "Nome",
    "tableEmail": "Email",
    "tableRole": "Ruolo",
    "tableOrganizer": "Organizzatore",
    "tablePosition": "Posizione",
    "tableSent": "Inviate",
    "tableReceived": "Ricevute",
    "tableAccepted": "Accettate",
    "tableTotal": "Totale",
    "tableConnections": "Connessioni",
    "tableUser": "Utente",
    "statusUpcoming": "Prossimo",
    "statusPast": "Passato",
    "statusCancelled": "Annullato",
    "roleAdmin": "Admin",
    "roleUser": "Utente",
    "loading": "Caricamento...",
    "loadingEvents": "Caricamento eventi...",
    "loadingUsers": "Caricamento utenti...",
    "loadingRankings": "Caricamento classifiche...",
    "noEvents": "Nessun evento",
    "noUsers": "Nessun utente",
    "noRankings": "Nessun dato di classifica disponibile",
    "makeAdmin": "Rendi Admin",
    "removeAdmin": "Rimuovi Admin",
    "eventsCount": "Eventi",
    "usersCount": "Utenti",
    "confirmDeleteEvent": "Sei sicuro di voler eliminare l'evento \"{title}\"? Questa azione non può essere annullata.",
    "roleUpdated": "Ruolo aggiornato correttamente",
    "roleUpdateError": "Impossibile aggiornare il ruolo",
    "eventDeleted": "Evento eliminato correttamente",
    "eventDeleteError": "Impossibile eliminare l'evento",
    "orgCreated": "Organizzazione creata correttamente",
    "orgCreateError": "Impossibile creare l'organizzazione",
    "dashboardTodayBanner": "{count} eventos comienzan HOY",
    "dashboardPlatformHealth": "Salud de Plataforma",
    "dashboardHealthNewUsers": "Usuarios nuevos (7 días)",
    "dashboardHealthPublishedEvents": "Eventos publicados",
    "dashboardHealthNewOrgs": "Empresas nuevas (7 días)",
    "dashboardDraftPastSummary": "{draft} borradores · {past} finalizados",
    "dashboardBadgeLive": "EN VIVO",
    "dashboardBadgeScheduled": "PROGRAMADO",
    "dashboardViewAllUpcoming": "Ver todos ({count}) →",
    "dashboardNewOrganization": "Nueva Empresa",
    "dashboardViewPermissions": "Ver Permisos"
  },
  "organizer": {
    "title": "Pannello organizzatore",
    "dashboard": "Dashboard",
    "events": "Eventi",
    "attendees": "Partecipanti",
    "networking": "Networking",
    "analytics": "Analytics",
    "notifications": "Notifiche",
    "settings": "Impostazioni organizzazione",
    "loading": "Caricamento...",
    "selectEvent": "Seleziona un evento",
    "noData": "Nessun dato",
    "noDataDescription": "Impossibile caricare i dati.",
    "dashboardTitle": "Dashboard",
    "dashboardDescription": "Riepilogo dei tuoi eventi e metriche. Seleziona una sezione dal menu per iniziare.",
    "dashboardLoading": "Caricamento riepilogo...",
    "dashboardKpiTotalEvents": "Totale eventi",
    "dashboardKpiDraft": "Bozze",
    "dashboardKpiPublished": "Pubblicati",
    "dashboardKpiPast": "Conclusi",
    "dashboardKpiCancelled": "Annullati",
    "dashboardKpiTotalAttendees": "Partecipanti registrati",
    "dashboardKpiTotalActiveAttendees": "Partecipanti attivi",
    "dashboardNoPublishedHint": "Non hai ancora eventi pubblicati. Pubblicane uno per vedere le metriche.",
    "dashboardKpiTotalConnections": "Connessioni generate",
    "dashboardKpiTotalMessages": "Messaggi inviati",
    "dashboardKpiAvgConnections": "Connessioni per evento (media)",
    "dashboardKpiAvgProfile": "Profilo completato (media)",
    "dashboardUpcomingEvents": "Prossimi eventi",
    "dashboardNoUpcoming": "Nessun evento in programma",
    "dashboardNoUpcomingDescription": "Pubblica un evento perché appaia qui.",
    "dashboardTopNetworking": "Eventi con più networking",
    "dashboardTopNetworkingConnections": "connessioni",
    "dashboardNoNetworking": "Nessun dato di networking",
    "dashboardNoNetworkingDescription": "Quando i tuoi eventi genereranno connessioni, appariranno qui.",
    "dashboardCreateEvent": "Crea evento",
    "dashboardViewAnalytics": "Vedi analytics",
    "dashboardViewEvents": "Vedi eventi",
    "dashboardEmptyTitle": "Non hai ancora eventi",
    "dashboardEmptyDescription": "Crea il tuo primo evento per iniziare a vedere metriche e statistiche.",
    "dashboardEventDate": "Data",
    "dashboardEventAttendees": "partecipanti",
    "eventsTitle": "Eventi",
    "eventsNew": "Nuovo evento",
    "eventsFilterStatus": "Stato:",
    "eventsFilterAll": "Tutti",
    "eventsFilterPublished": "Pubblicati",
    "eventsFilterDraft": "Bozza",
    "eventsFilterPast": "Passati",
    "eventsFilterCancelled": "Annullati",
    "eventsFilterUpcoming": "Prossimi",
    "eventsFilterDate": "Data:",
    "eventsTableLocation": "Luogo",
    "eventsStatusPublished": "Pubblicato",
    "eventsStatusDraft": "Bozza",
    "eventsStatusArchived": "Archiviato",
    "eventsStatusCancelled": "Annullato",
    "eventsTableTitle": "Titolo",
    "eventsTableDate": "Data",
    "eventsTableStatus": "Stato",
    "eventsTableCapacity": "Capacità",
    "eventsTableActions": "Azioni",
    "eventsEdit": "Modifica",
    "eventsCopyLink": "Copia link",
    "eventsLinkCopied": "Link copiato",
    "eventsLanding": "Landing",
    "eventsPublish": "Pubblica",
    "eventsUnpublish": "Ritira",
    "eventsArchive": "Archivia",
    "eventsCancel": "Annulla evento",
    "eventsNoEvents": "Nessun evento",
    "eventsNoEventsDescription": "Crea il tuo primo evento per iniziare.",
    "eventsNoCapacity": "Senza limite",
    "eventNewTitle": "Nuovo evento",
    "eventNewNoOrg": "Devi appartenere a un'organizzazione per creare eventi. Crea prima un'organizzazione o chiedi di essere aggiunto come org_admin.",
    "eventNewBackToEvents": "Torna agli Eventi",
    "eventEditTitle": "Modifica evento",
    "attendeesTitle": "Partecipanti",
    "attendeesSendNotification": "Invia notifica",
    "attendeesNoAttendees": "Nessun partecipante",
    "attendeesNoAttendeesDescription": "Nessun iscritto a questo evento.",
    "attendeesLoading": "Caricamento partecipanti...",
    "attendeesTableName": "Nome",
    "attendeesTableEmail": "Email",
    "attendeesTableStatus": "Stato",
    "attendeesTableDate": "Data registrazione",
    "attendeesTableProfile": "Profilo",
    "networkingTitle": "Networking",
    "networkingLoading": "Caricamento metriche...",
    "networkingSentRequests": "Richieste inviate",
    "networkingAcceptedRequests": "Richieste accettate",
    "networkingTotalConnections": "Connessioni totali",
    "networkingAcceptanceRatio": "Tasso di accettazione",
    "networkingTopConnectors": "Top connettori",
    "networkingNoData": "Nessun dato",
    "networkingNoDataDescription": "Ancora nessuna connessione tra i partecipanti.",
    "networkingNoDataGeneric": "Impossibile caricare le metriche.",
    "networkingConnections": "connessioni",
    "networkingAttendeesCount": "Partecipanti iscritti",
    "networkingHintLowEngagement": "Solo alcuni partecipanti hanno creato connessioni.",
    "networkingHintCta": "Invia una notifica per incentivare il networking",
    "analyticsTitle": "Analytics",
    "analyticsLoading": "Caricamento analytics...",
    "analyticsRegistered": "Registrati",
    "analyticsActive": "Attivi",
    "analyticsActiveHelp": "Iscritti segnati come «presenti» (check-in durante l’evento)",
    "analyticsTotalAttendedHelp": "Iscritti segnati come «hanno partecipato» dopo l’evento",
    "analyticsRegisteredHelp": "Solo chi ha cliccato «Iscriviti» all'evento nell'app (non tutti gli utenti con account)",
    "analyticsProfileComplete": "% Profilo completo",
    "analyticsSentRequests": "Richieste inviate",
    "analyticsAcceptedRequests": "Richieste accettate",
    "analyticsTotalConnections": "Connessioni totali",
    "analyticsAcceptanceRatio": "Tasso di accettazione",
    "analyticsMessagesSent": "Messaggi inviati",
    "analyticsActiveConversations": "Conversazioni attive",
    "analyticsActiveConversationsHelp": "Chat con almeno un messaggio (DM tra partecipanti + chat dell'evento)",
    "analyticsConnectionsPerAttendee": "Connessioni per partecipante (media)",
    "analyticsFunnel": "Imbuto",
    "analyticsRegistrationsByDay": "Registrazioni per giorno",
    "analyticsDate": "Data",
    "analyticsRegistrations": "Registrazioni",
    "analyticsTopInterests": "Top interessi",
    "analyticsTopGoals": "Top obiettivi",
    "analyticsShareableSummary": "Riepilogo condivisibile",
    "meetups": {
      "sectionTitle": "Incontri confermati",
      "kpiTotal": "Totale",
      "kpi24h": "Ultime 24 h",
      "kpi7d": "Ultimi 7 giorni",
      "empty": "Nessun incontro confermato",
      "emptyHint": "Qui compaiono gli incontri di persona confermati dai partecipanti di questo evento scansionando il QR monouso.",
      "methodQr": "QR",
      "methodUnknown": "—"
    },
    "analyticsCopyClipboard": "Copia negli appunti",
    "analyticsCopied": "Copiato",
    "analyticsNoData": "Nessun dato",
    "analyticsNoDataDescription": "Impossibile caricare le metriche per questo evento.",
    "analyticsFilterAll": "Tutti",
    "analyticsFilterUpcoming": "In programma",
    "analyticsFilterPast": "Terminati",
    "analyticsEventHeaderViewEvent": "Vedi evento",
    "analyticsEventHeaderCopyLink": "Copia link",
    "analyticsEventHeaderViewAttendees": "Vedi partecipanti",
    "analyticsEventHeaderSendNotification": "Invia notifica",
    "analyticsStatusUpcoming": "In programma",
    "analyticsStatusOngoing": "In corso",
    "analyticsStatusPast": "Terminato",
    "analyticsStatusCancelled": "Annullato",
    "analyticsSectionAttendance": "Presenze e registrazione",
    "analyticsSectionNetworking": "Networking e coinvolgimento",
    "analyticsSectionFunnel": "Imbuto di partecipazione",
    "analyticsSectionSummary": "Riepilogo condivisibile",
    "analyticsLastUpdate": "Ultimo aggiornamento",
    "analyticsEmptyNoEvents": "Non hai ancora eventi",
    "analyticsEmptyNoEventsDescription": "Crea il tuo primo evento per vedere le analitiche.",
    "analyticsEmptyNoRegistrations": "Nessuno si è ancora iscritto a questo evento.",
    "analyticsEmptyNoNetworkingTitle": "Nessuna attività di networking ancora",
    "analyticsEmptyNoNetworkingCta": "Invia una notifica per attivare il networking tra i partecipanti.",
    "analyticsMetricUnavailable": "Nessun dato ancora",
    "analyticsCopySummary": "Copia riepilogo",
    "analyticsFunnelRegistered": "Registrati",
    "analyticsFunnelProfileComplete": "Profilo completo",
    "analyticsFunnelSentRequest": "Hanno inviato richiesta",
    "analyticsFunnelConnected": "Connessi",
    "analyticsFunnelChatted": "Hanno chattato",
    "analyticsTotalRegistered": "Totale registrati",
    "analyticsTotalAttended": "Totale presenti",
    "analyticsAttendanceRate": "Tasso di presenza",
    "analyticsCancelled": "Annullati",
    "analyticsSelectEventPlaceholder": "Seleziona evento",
    "analyticsEmptySelectEvent": "Seleziona un evento per vedere le metriche",
    "notificationsTitle": "Notifiche",
    "notificationsSendToAttendees": "Invia ai partecipanti dell'evento",
    "notificationsTitlePlaceholder": "Titolo",
    "notificationsMessagePlaceholder": "Messaggio",
    "notificationsSend": "Invia",
    "notificationsSending": "Invio in corso...",
    "notificationsHistory": "Cronologia campagne",
    "notificationsNoCampaigns": "Nessuna campagna",
    "notificationsNoCampaignsDescription": "Non hai ancora inviato notifiche a questo evento.",
    "settingsPageTitle": "Impostazioni",
    "settingsOrgSection": "Organizzazione",
    "settingsOrgName": "Nome organizzazione",
    "settingsTeamSection": "Team",
    "settingsTeamRoleAdmin": "Amministratore",
    "settingsTeamRoleMember": "Membro",
    "settingsTeamRemove": "Rimuovi dal team",
    "settingsRemoveConfirm": "Rimuovere questo utente dal team?",
    "settingsTeamOwner": "proprietario",
    "settingsTableName": "Nome",
    "settingsTableEmail": "Email",
    "settingsTableRole": "Ruolo",
    "settingsSave": "Salva",
    "settingsSaved": "Salvato",
    "settingsLoading": "Caricamento…",
    "settingsNoOrg": "Non hai nessuna organizzazione. Creane una dal pannello di amministrazione.",
    "brandingSectionTitle": "Company branding",
    "brandingSectionDesc": "Logo and colors applied to your organization's events.",
    "brandingLogoLabel": "Logo",
    "brandingLogoHint": "Drag an image or click (max. 2 MB)",
    "brandingLogoUpload": "Upload logo",
    "brandingLogoRemove": "Remove logo",
    "brandingUploading": "Uploading…",
    "brandingPrimary": "Primary color",
    "brandingSecondary": "Secondary color",
    "brandingContrastWarning": "Secondary color may have low contrast with white text on badges.",
    "brandingPreviewLabel": "Live preview",
    "brandingSaved": "Branding saved",
    "brandingSaveError": "Could not save branding",
    "brandingUploadError": "Failed to upload logo",
    "plataforma": "Piattaforma",
    "dashboardKpiRegistered": "Inscritos totales",
    "dashboardKpiAttendance": "Asistencia",
    "dashboardKpiEngagement": "Engagement",
    "dashboardTrendThisWeek": "esta semana",
    "dashboardNextActions": "Próximas acciones",
    "dashboardActionEventsWeek": "{count} eventos comienzan esta semana",
    "dashboardActionPendingCheckIn": "{count} inscritos sin check-in confirmado",
    "dashboardActionConnections": "Revisa las nuevas conexiones en Networking",
    "dashboardMyEvents": "Mis eventos",
    "dashboardAttendeesShort": "inscritos",
    "dashboardBadgeLive": "EN DIRECTO",
    "dashboardBadgeScheduled": "Programado",
    "dashboardQuickActionsTitle": "Acciones",
    "dashboardViewAttendees": "Ver asistentes",
    "dashboardSendNotification": "Enviar notificación",
    "dashboardQuickAnalytics": "Analytics rápido",
    "dashboardExportCsv": "Exportar CSV",
    "dashboardCreateEventShort": "+ Create event",
    "dashboardViewAllEvents": "View all ({count})"
  },
  "panel": {
    "title": "Pannello",
    "admin": "Pannello amministrazione",
    "organizer": "Pannello organizzatore",
    "desktopOnly": {
      "title": "Disponibile su tablet e desktop",
      "description": "I pannelli di amministrazione e organizzatore sono pensati per schermi più grandi. Aprili da un tablet o un computer.",
      "backToEvents": "Torna agli eventi"
    }
  },
  "navigation": {
    "eventos": "Eventi",
    "chats": "Chat",
    "perfil": "Profilo",
    "ajustes": "Impostazioni",
    "votacion": "Aiutaci!",
    "quienesSomos": "Chi siamo",
    "actividad": "Attività",
    "closeMenu": "Chiudi menu",
    "panel": "Pannello",
    "panelAdmin": "Pannello amministrazione",
    "panelOrganizer": "Pannello organizzatore"
  },
  "events": {
    "title": "Eventi",
    "greeting": "Ciao",
    "upcomingEvent": "evento in arrivo",
    "upcomingEvents": "eventi in arrivo",
    "noUpcoming": "Nessun evento in arrivo",
    "recommendationHint": "Per ricevere raccomandazioni personalizzate sui partecipanti, registrati agli eventi che ti interessano.",
    "recommendationHintShort": "Iscriviti agli eventi per ricevere raccomandazioni personalizzate.",
    "loading": "Caricamento eventi...",
    "hidePast": "Nascondi eventi passati",
    "showPast": "Mostra eventi passati",
    "noEvents": "Nessun evento",
    "noEventsMessage": "Al momento non ci sono eventi programmati. Torna presto per scoprire nuove opportunità di connessione e apprendimento.",
    "live": "IN DIRETTA",
    "registered": "Registrato",
    "full": "Completo",
    "register": "Registrati",
    "sectionUpcoming": "Prossimi eventi",
    "sectionPast": "Eventi passati",
    "filterAll": "Tutti",
    "filterRegistered": "Registrato",
    "filterPast": "Passati",
    "upcomingBadge": "Prossimo",
    "participants": {
      "zero": "0 partecipanti",
      "one": "1 partecipante",
      "many": "{count} partecipanti"
    },
    "capacity": {
      "full": "Completo ({max}/{max})",
      "oneLeft": "{current}/{max} posti (1 disponibile)",
      "available": "{current}/{max} posti ({available} disponibili)"
    }
  },
  "eventDetail": {
    "loading": "Caricamento evento...",
    "notFound": "Evento non trovato",
    "backToEvents": "Torna agli eventi",
    "back": "Indietro",
    "live": "IN DIRETTA",
    "description": "Descrizione",
    "registration": {
      "title": "Iscrizione",
      "subtitle": "Prenota il tuo posto e ricevi tutte le informazioni necessarie per partecipare.",
      "full": "Evento completo ({max}/{max} posti)",
      "capacity": "{count}/{max} posti occupati ({available} disponibili)",
      "limitedSeats": "Posti limitati: conferma la tua partecipazione per assicurarti il posto.",
      "pastEvent": "Questo evento è già terminato, consulta il calendario per nuovi incontri.",
      "alreadyRegistered": "Sei già registrato e riceverai le novità dell'evento.",
      "unregisterLoading": "Annullamento iscrizione...",
      "unregister": "Annulla iscrizione",
      "eventFull": "Questo evento è completo. Non ci sono posti disponibili.",
      "registerLoading": "Salvataggio del tuo posto...",
      "registerButton": "Iscrivimi all'evento",
      "checkingRegistration": "Verifica se sei già registrato...",
      "loadingProfile": "Caricamento del tuo profilo per abilitare l'iscrizione...",
      "registeredTitle": "Sei iscritto!",
      "registeredEmailHint": "Ti invieremo tutte le informazioni via email"
    },
    "registrationGoal": {
      "title": "Qual è il tuo obiettivo per questo evento?",
      "subtitle": "Dicci cosa cerchi in \"{eventTitle}\" per consigliarti persone con interessi affini.",
      "placeholder": "Es.: Fare networking con sviluppatori, cercare investitori, imparare nuove tecnologie...",
      "submit": "Iscriviti e calcola i match ✨",
      "saveObjective": "Salva obiettivo ✨",
      "profileSaveError": "Non siamo riusciti a salvare il tuo obiettivo. Riprova.",
      "error": "Scrivi un obiettivo per aiutarti a connetterti meglio.",
      "tagsTitle": "Suggerimenti rapidi (puoi sceglierne più di uno):",
      "tag1": "🤝 Trovare soci o collaboratori",
      "tag2": "💼 Cercare opportunità di business",
      "tag3": "✨ Fare networking e contatti",
      "tag4": "📚 Imparare e acquisire conoscenze",
      "tag5": "🚀 Conoscere persone del settore"
    },
    "tabs": {
      "agenda": "Agenda",
      "speakers": "Relatori",
      "recommendations": "Raccomandazioni",
      "notifications": "Notifiche",
      "location": "Posizione"
    },
    "agenda": {
      "title": "Agenda",
      "noAgenda": "Nessuna agenda disponibile per questo evento."
    },
    "speakers": {
      "title": "Relatori",
      "noSpeakers": "Nessun relatore registrato per questo evento."
    },
    "recommendations": {
      "recommended": "Raccomandati",
      "allAttendees": "Tutti i partecipanti",
      "title": "Persone Raccomandate",
      "subtitle": "Persone iscritte all'evento che potrebbero interessarti.",
      "calculating": "Calcolo raccomandazioni...",
      "noRecommendations": "Nessuna raccomandazione disponibile al momento.",
      "attendeesTitle": "Partecipanti all'evento",
      "attendeesSubtitle": "Persone che hanno già confermato la loro partecipazione.",
      "loadingAttendees": "Caricamento partecipanti...",
      "beFirst": "Sii la prima persona a registrarsi all'evento.",
      "connect": "Connetti",
      "requestSent": "Richiesta inviata",
      "openChat": "Apri chat"
    },
    "notifications": {
      "title": "Notifiche dell'Evento",
      "loading": "Caricamento notifiche...",
      "noNotifications": "Nessuna notifica per questo evento.",
      "noNotificationsHint": "Le notifiche relative a questo evento appariranno qui.",
      "now": "Adesso",
      "minutesAgo": "{mins} min fa",
      "hoursAgo": "{hours} h fa",
      "daysAgo": "{days} g fa",
      "eventNotification": "Notifica dell'evento",
      "noMessage": "Nessun messaggio",
      "new": "Nuova",
      "markAsRead": "Segna come letta"
    },
    "location": {
      "title": "Posizione",
      "openInMaps": "Apri in Google Maps",
      "notAvailable": "Posizione non disponibile",
      "howToArrive": "Come vuoi arrivare?",
      "byCar": "In auto",
      "byTransit": "Trasporto pubblico",
      "byBicycle": "In bicicletta",
      "byWalking": "A piedi",
      "gettingLocation": "Ottenimento della tua posizione...",
      "cantCalculate": "Impossibile calcolare il percorso senza una posizione valida."
    },
    "errors": {
      "profileNotFound": "Non siamo riusciti a identificare il tuo profilo. Ricarica la pagina e riprova.",
      "registrationFailed": "Non siamo riusciti a completare la tua registrazione. Riprova tra qualche secondo.",
      "registrationError": "Si è verificato un errore durante la registrazione. Per favore, riprova più tardi.",
      "unregisterConfirm": "Sei sicuro di voler annullare l'iscrizione a questo evento?",
      "unregisterFailed": "Non siamo riusciti a cancellare la tua registrazione. Riprova tra qualche secondo.",
      "unregisterError": "Si è verificato un errore durante l'annullamento della registrazione. Per favore, riprova più tardi.",
      "geolocationNotSupported": "Geolocalizzazione non supportata",
      "locationNotAvailable": "Posizione non disponibile",
      "locationAccessDenied": "Non siamo riusciti ad accedere alla tua posizione. Apertura Maps con la destinazione dell'evento.",
      "directionsError": "Si è verificato un errore durante l'apertura delle indicazioni.",
      "loadAttendeesError": "Non siamo riusciti a caricare i partecipanti confermati."
    },
    "readMore": "Leggi di più",
    "readLess": "Mostra meno",
    "spotsRemaining": "{count} posti rimasti"
  },
  "chats": {
    "title": "Chat",
    "activity": {
      "feedTitle": "Attività",
      "feedSubtitle": "Richieste, messaggi e connessioni",
      "markAllRead": "Segna tutto come letto",
      "error": "Impossibile caricare l'attività.",
      "retry": "Riprova",
      "empty": "Non hai ancora attività",
      "emptyHint": "Richieste di connessione, accettazioni e messaggi appariranno qui.",
      "exploreEvents": "Esplora eventi",
      "someone": "Qualcuno",
      "newMessage": "Nuovo messaggio",
      "sentRequest": "ti ha inviato una richiesta",
      "requestSent": "Richiesta inviata",
      "requestAccepted": "ha accettato la tua richiesta"
    },
    "recentActivity": "La tua attività recente",
    "loading": "Caricamento...",
    "noChats": "Non hai ancora chat",
    "noChatsHint": "Registrati a un evento per connetterti e parlare con più persone",
    "tabs": {
      "activity": "Attività",
      "connections": "Connessioni",
      "chats": "Chat"
    },
    "requests": {
      "title": "Richieste",
      "allContacts": "Tutti i tuoi contatti",
      "favorites": "Preferiti",
      "sent": {
        "title": "Richieste Inviate",
        "pending": "richiesta in sospeso",
        "pendingPlural": "richieste in sospeso",
        "waiting": "In attesa di risposta",
        "cancel": "Annulla"
      },
      "received": {
        "title": "Richieste di Connessione",
        "pending": "richiesta in sospeso",
        "pendingPlural": "richieste in sospeso",
        "wantsToConnect": "Vuole connettersi con te",
        "accept": "Accetta",
        "reject": "Rifiuta",
        "noPending": "Nessuna richiesta in sospeso"
      }
    },
    "contacts": {
      "noContacts": "Non hai contatti connessi",
      "noContactsHint": "Connettiti con altri utenti per vederli qui",
      "removeFavorite": "Rimuovi dai preferiti",
      "addFavorite": "Aggiungi ai preferiti",
      "openChat": "Apri chat",
      "noFavorites": "Non hai contatti preferiti",
      "noFavoritesHint": "Segna i contatti come preferiti per vederli qui"
    },
    "connections": {
      "acceptSuccessTitle": "Connessione accettata",
      "acceptSuccessMessage": "Ora puoi chattare con questo contatto.",
      "acceptErrorMessage": "Impossibile accettare la richiesta.",
      "rejectSuccessTitle": "Richiesta rifiutata",
      "rejectSuccessMessage": "Hai rifiutato la richiesta di connessione.",
      "rejectErrorMessage": "Impossibile rifiutare la richiesta.",
      "cancelSuccessTitle": "Richiesta annullata",
      "cancelSuccessMessage": "Hai annullato la richiesta di connessione.",
      "cancelErrorMessage": "Impossibile annullare la richiesta.",
      "viewRequests": "Visualizza richieste",
      "dmBlockedTitle": "Connessione richiesta",
      "dmBlockedMessage": "Accetta la richiesta di connessione per chattare.",
      "alreadyPending": "C'è già una richiesta in sospeso tra voi.",
      "alreadyConnected": "Siete già connessi.",
      "cooldownActive": "Attendi un momento prima di inviare di nuovo la richiesta.",
      "rateLimited": "Troppe richieste. Attendi un momento e riprova."
    },
    "search": "Cerca o inizia nuova chat",
    "noRecentChats": "Nessuna chat recente",
    "selectChat": "Seleziona una chat",
    "selectChatHint": "Scegli una conversazione dalla lista per iniziare a chattare",
    "myActivity": "La Mia Attività",
    "allUsers": "Tutti gli Utenti",
    "recentActivityTitle": "Attività Recente",
    "lastActions": "Ultime azioni",
    "noActivity": "Nessuna attività recente",
    "noActivityHint": "La tua attività apparirà qui",
    "registeredUsers": "utenti registrati",
    "loadingUsers": "Caricamento utenti...",
    "disconnect": "Disconnetti",
    "pending": "In sospeso",
    "connect": "Connetti",
    "chat": "Chat",
    "noUsers": "Nessun utente registrato",
    "deleteConversation": {
      "title": "Elimina conversazione",
      "confirm": "Eliminare questa conversazione con {name}?",
      "hint": "Sarà nascosta dalla tua lista. Se arriva un nuovo messaggio, riapparirà.",
      "cancel": "Annulla",
      "deleting": "Eliminazione...",
      "delete": "Elimina",
      "button": "Elimina chat"
    },
    "errors": {
      "disconnectConfirm": "Sei sicuro di voler disconnettere questo utente?",
      "hideError": "Non è stato possibile nascondere la conversazione. Riprova.",
      "unexpectedError": "Errore imprevisto durante l'eliminazione della chat. Riprova."
    },
    "dm": {
      "deleteError": "Impossibile eliminare la chat. Riprova.",
      "deleteChat": "Elimina chat",
      "deleting": "Eliminazione..."
    }
  },
  "profile": {
    "loading": "Caricamento profilo...",
    "editPhoto": "Modifica foto profilo",
    "avatarUpdateError": "Impossibile salvare la foto del profilo. Riprova.",
    "avatarUploadError": "Impossibile caricare la foto. Riprova.",
    "avatarCropTitle": "Regola la foto",
    "avatarCropHint": "Trascina e usa lo zoom per inquadrare il viso nel cerchio.",
    "avatarCropZoom": "Zoom",
    "avatarCropCancel": "Annulla",
    "avatarCropSave": "Usa foto",
    "avatarCropError": "Impossibile ritagliare l'immagine. Riprova.",
    "avatarCropInvalidType": "Seleziona un file immagine valido.",
    "roles": {
      "admin": "Amministratore",
      "user": "Utente"
    },
    "experience": {
      "beginner": "Principiante",
      "intermediate": "Intermedio",
      "advanced": "Avanzato",
      "expert": "Esperto"
    },
    "whoAmI": {
      "student": "Studente",
      "professional": "Professionista",
      "entrepreneur": "Imprenditore",
      "investor": "Investitore",
      "mentor": "Mentore",
      "other": "Altro"
    },
    "goals": {
      "networking": "Networking",
      "learn": "Imparare",
      "opportunities": "Opportunità",
      "mentorship": "Mentorship",
      "collaborate": "Collaborare",
      "share": "Condividere",
      "personalBrand": "Personal Brand",
      "explore": "Esplorare"
    },
    "fields": {
      "email": "EMAIL",
      "phone": "TELEFONO",
      "birthday": "COMPLEANNO",
      "location": "POSIZIONE"
    },
    "tabs": {
      "aboutMe": "Chi Sono",
      "networking": "Networking",
      "info": "Informazioni",
      "interests": "Interessi",
      "social": "Social Network"
    },
    "completeness": {
      "label": "Profilo completato",
      "subtitle": "Completa il tuo profilo per ricevere migliori suggerimenti di networking.",
      "matchHint": "I profili con più informazioni ricevono migliori match di networking.",
      "completeProfile": "Completa profilo",
      "completeNext": "Completa",
      "allDone": "Profilo completo! Riceverai i migliori match.",
      "personalInfo": "Informazioni personali",
      "interests": "Interessi",
      "eventObjective": "Obiettivo all'evento",
      "socialNetworks": "Social network",
      "professionalExperience": "Esperienza professionale",
      "bio": "Bio",
      "networkingLevel": "Livello Networking",
      "hint_personal_info": "Aggiungi il tuo nome e cognome",
      "hint_interests": "Aggiungi i tuoi interessi professionali",
      "hint_event_objective": "Indica il tuo obiettivo all'evento",
      "hint_social_networks": "Aggiungi almeno un social network",
      "hint_professional_experience": "Indica il tuo ruolo e livello di esperienza",
      "hint_bio": "Aggiungi una breve bio su di te"
    },
    "networking": {
      "title": "Networking",
      "seeking": "Cerco di connettermi con",
      "seekingTagInputPlaceholder": "Scrivi il tipo di persone che vuoi incontrare e premi Invio (es. founder, investitori, sviluppatori)",
      "offering": "Cosa offro",
      "offeringTagInputPlaceholder": "Scrivi cosa puoi offrire e premi Invio (es. mentoring, collaborazione, assunzione)",
      "eventObjective": "Obiettivo all'evento",
      "bioShort": "Bio (max 200 caratteri)",
      "bioShortPlaceholder": "Es: Founder building AI products. Interested in meeting developers and investors.",
      "professionalKeywords": "Tag professionali",
      "seeking_investors": "Investitori",
      "seeking_founders": "Fondatori",
      "seeking_developers": "Sviluppatori",
      "seeking_designers": "Designer",
      "seeking_marketing": "Marketing",
      "seeking_product_managers": "Product Managers",
      "offering_mentorship": "Mentoring",
      "offering_investment": "Investimento",
      "offering_collaboration": "Collaborazione",
      "offering_hiring": "Assumere talenti",
      "offering_finding_partners": "Trovare partner",
      "offering_sharing_knowledge": "Condividere conoscenza",
      "eventObjective_networking": "Networking",
      "eventObjective_finding_partners": "Trovare partner",
      "eventObjective_finding_clients": "Trovare clienti",
      "eventObjective_investment": "Investimento",
      "eventObjective_learning": "Imparare",
      "eventObjective_recruiting": "Reclutare talenti"
    },
    "matchScore": {
      "title": "Il tuo profilo genera match con",
      "subtitle": "Completa il tuo profilo per migliorare i suggerimenti.",
      "empty": "Completa la sezione Networking per vedere le compatibilità.",
      "developersAI": "Sviluppatori IA",
      "foundersSaaS": "Fondatori SaaS",
      "investors": "Investitori",
      "developers": "Sviluppatori",
      "designers": "Designer",
      "marketing": "Marketing",
      "productManagers": "Product Managers",
      "fintech": "Fintech / Blockchain"
    },
    "aboutMe": {
      "title": "Chi Sono",
      "edit": "Modifica",
      "biography": "Biografia",
      "biographyPlaceholder": "Descrivi brevemente cosa fai e chi vorresti incontrare (es. Founder che costruisce prodotti AI, interessato a incontrare sviluppatori e investitori).",
      "cancel": "Annulla",
      "save": "Salva",
      "noBio": "Aggiungi una bio breve per far capire rapidamente agli altri partecipanti chi sei.",
      "addBio": "Aggiungi bio",
      "whatIDo": "Cosa Faccio",
      "noWhatIDo": "Completa questa sezione per far sapere agli altri cosa fai.",
      "role": "Ruolo",
      "experience": "Esperienza",
      "goals": "Obiettivi",
      "preferences": "Preferenze"
    },
    "personalInfo": {
      "title": "Informazioni Personali",
      "edit": "Modifica",
      "firstName": "Nome",
      "lastName": "Cognome",
      "birthDate": "Data di Nascita",
      "phone": "Telefono",
      "email": "Email",
      "systemRole": "Ruolo di Sistema",
      "cancel": "Annulla",
      "save": "Salva"
    },
    "address": {
      "title": "Indirizzo",
      "edit": "Modifica",
      "city": "Città",
      "cancel": "Annulla",
      "save": "Salva"
    },
    "interests": {
      "title": "Interessi",
      "edit": "Modifica",
      "placeholder": "Innovazione, Startup, Design...",
      "tagInputPlaceholder": "Scrivi un interesse e premi Invio (es. AI, Startup, Design)",
      "label": "Interessi",
      "cancel": "Annulla",
      "save": "Salva",
      "general": "Interessi Generali",
      "onboarding": "Interessi dall'Onboarding",
      "noInterests": "Non hai ancora aggiunto interessi."
    },
    "social": {
      "title": "Social Network",
      "edit": "Modifica",
      "linkedin": "LinkedIn",
      "linkedinPlaceholder": "https://linkedin.com/in/utente",
      "twitter": "X (Twitter)",
      "twitterPlaceholder": "https://twitter.com/utente",
      "instagram": "Instagram",
      "instagramPlaceholder": "https://instagram.com/utente",
      "github": "GitHub",
      "githubPlaceholder": "https://github.com/utente",
      "facebook": "Facebook",
      "facebookPlaceholder": "https://facebook.com/utente",
      "youtube": "YouTube",
      "youtubePlaceholder": "https://youtube.com/canale",
      "tiktok": "TikTok",
      "tiktokPlaceholder": "https://tiktok.com/@utente",
      "website": "Sito Web",
      "websitePlaceholder": "https://il-mio-sito.com",
      "cancel": "Annulla",
      "save": "Salva",
      "noSocial": "Non hai ancora aggiunto social network.",
      "emptyHint": "Aggiungi i tuoi social affinché altri partecipanti possano conoscerti meglio.",
      "addSocialNetworks": "Aggiungi social"
    },
    "errors": {
      "noChanges": "Nessuna modifica da salvare.",
      "updateError": "Errore: Non è stato possibile aggiornare il profilo. Riprova.",
      "saveError": "Errore: Si è verificato un errore durante il salvataggio del profilo. Riprova.",
      "avatarError": "Errore durante l'aggiornamento dell'avatar"
    }
  },
  "activity": {
    "title": "La Mia Attività",
    "subtitle": "Il tuo pannello personale di eventi e attività recente",
    "loading": "Caricamento attività...",
    "noActivity": "Non hai ancora attività",
    "noActivityHint": "Inizia esplorando eventi e registrandoti per vedere la tua attività qui",
    "exploreEvents": "Esplora Eventi",
    "sentRequests": {
      "title": "Richieste Inviate",
      "pending": "richiesta in sospeso",
      "pendingPlural": "richieste in sospeso",
      "waiting": "In attesa di risposta",
      "cancel": "Annulla"
    },
    "receivedRequests": {
      "title": "Richieste di Connessione",
      "pending": "richiesta in sospeso",
      "pendingPlural": "richieste in sospeso",
      "wantsToConnect": "Vuole connettersi con te",
      "accept": "Accetta",
      "reject": "Rifiuta"
    },
    "registeredEvents": {
      "title": "Eventi Registrati",
      "event": "evento",
      "events": "eventi"
    },
    "recentActivity": {
      "title": "Attività Recente",
      "subtitle": "Ultime azioni"
    }
  },
  "aboutUs": {
    "title": "Chi Siamo",
    "hero": {
      "title": "Benvenuto in Biavent",
      "description": "Biavent è una piattaforma progettata per connettere persone con interessi comuni, facilitare il networking professionale e creare opportunità di crescita personale e professionale."
    },
    "features": {
      "connections": {
        "title": "Connessioni",
        "description": "Connettiti con professionisti del tuo settore ed espandi la tua rete di contatti."
      },
      "events": {
        "title": "Eventi",
        "description": "Partecipa ad eventi esclusivi e scopri nuove opportunità di crescita."
      },
      "community": {
        "title": "Comunità",
        "description": "Unisciti a una comunità attiva di persone che condividono i tuoi interessi e valori."
      }
    }
  },
  "chat": {
    "event": {
      "loading": "Caricamento chat...",
      "loadingMessages": "Caricamento messaggi...",
      "title": "Chat dell'Evento",
      "noMessages": "Nessun messaggio ancora. Sii il primo a scrivere!",
      "user": "Utente",
      "placeholder": "Scrivi un messaggio...",
      "sending": "Invio...",
      "send": "Invia"
    },
    "dm": {
      "loading": "Caricamento chat...",
      "loadingMessages": "Caricamento messaggi...",
      "userError": "Errore: Non è stato possibile identificare l'utente corrente",
      "user": "Utente",
      "noMessages": "Nessun messaggio ancora",
      "startConversation": "Inizia la conversazione!",
      "placeholder": "Scrivi a {name}...",
      "sending": "Invio...",
      "send": "Invia"
    }
  },
  "settings": {
    "title": "Impostazioni",
    "subtitle": "Gestisci le tue preferenze",
    "appearance": {
      "title": "Aspetto",
      "theme": {
        "label": "Tema",
        "auto": "Automatico (come il dispositivo)",
        "light": "Chiaro",
        "dark": "Scuro",
        "description": "Scegli come vuoi che appaia l'applicazione"
      }
    },
    "language": {
      "title": "Lingua",
      "label": "Lingua",
      "auto": "Automatico (secondo il dispositivo)",
      "description": "Scegli la lingua dell'applicazione",
      "detected": "Rilevato"
    },
    "appTour": {
      "title": "Tutorial dell'app",
      "description": "Rivedi il tour guidato delle funzioni principali.",
      "replay": "Vedi di nuovo il tutorial"
    },
    "notifications": {
      "title": "Notifiche",
      "subtitle": "Gestisci le tue preferenze di notifiche push"
    },
    "dataAndCache": {
      "title": "Dati e cache",
      "description": "Aggiorna i dati in cache o ricarica l'app per vedere le informazioni più recenti o risolvere problemi di caricamento.",
      "refreshData": "Aggiorna dati",
      "clearAndReload": "Svuota cache e ricarica",
      "refreshSuccess": "Cache svuotata. I nuovi dati si caricheranno quando navighi.",
      "reloading": "Ricarica in corso..."
    }
  },
  "votacion": {
    "title": "Aiutaci!",
    "subtitle": "La tua opinione è molto preziosa per noi. Condividi i tuoi suggerimenti, idee e commenti per aiutarci a migliorare.",
    "form": {
      "loading": "Caricamento modulo...",
      "eventLabel": "Seleziona evento",
      "foundErrorsLabel": "Hai trovato errori?",
      "yes": "Sì",
      "no": "No",
      "errorDetailsLabel": "Se sì, quali?",
      "errorDetailsPlaceholder": "Raccontaci quali errori hai trovato così possiamo correggerli.",
      "commentLabel": "Vuoi aggiungere un commento sull'evento? (opzionale)",
      "commentPlaceholder": "Può essere una critica costruttiva, cosa ti è piaciuto o qualsiasi altra osservazione.",
      "submit": "Invia feedback",
      "submitting": "Invio feedback..."
    },
    "messages": {
      "profileError": "Non siamo riusciti a caricare il tuo profilo. Riprova.",
      "selectEventRequired": "Seleziona un evento per continuare.",
      "selectErrorsRequired": "Indica se hai trovato errori.",
      "errorDetailsRequired": "Descrivi gli errori che hai trovato.",
      "submitError": "Non è stato possibile inviare il feedback. Riprova.",
      "submitSuccess": "Grazie per aiutarci a migliorare. Il tuo feedback è stato inviato correttamente.",
      "noEligibleEvents": "Non hai ancora eventi disponibili da valutare.",
      "alreadySentForEvent": "Hai già inviato feedback per questo evento.",
      "pickAnotherEvent": "Se vuoi, seleziona un altro evento per inviare altro feedback."
    }
  },
  "calendar": {
    "confirmationTitle": "Iscrizione completata!",
    "confirmationSubtitle": "Ti aspettiamo a {eventTitle}",
    "addToGoogleCalendar": "Aggiungi a Google Calendar",
    "addToAppleCalendar": "Aggiungi a Apple Calendar",
    "addToCalendar": "Aggiungi al calendario",
    "hint": "Questo aggiungerà l'evento al tuo calendario. Potrai modificarlo in seguito.",
    "downloadICS": "Scarica file .ics"
  },
  "eventWizard": {
    "progressAria": "Wizard progress",
    "stepMeta": "Passo {current} di {total}",
    "sections": {
      "identity": "Identità dell'evento",
      "visibility": "Visibilità",
      "configuration": "Configurazione",
      "storytelling": "Storytelling",
      "when": "Quando",
      "formatAndPlace": "Formato e luogo",
      "arrival": "Arrivo",
      "speakers": "Relatori",
      "agenda": "Agenda",
      "branding": "Branding",
      "review": "Riepilogo",
      "discovery": "Scoperta"
    },
    "steps": {
      "basic": "Basics",
      "location": "Location",
      "speakers": "Speakers",
      "agenda": "Agenda",
      "style": "Style",
      "review": "Review"
    },
    "nav": {
      "prev": "Back",
      "next": "Next",
      "cancel": "Cancel",
      "draft": "Save draft",
      "publish": "Create event",
      "saveChanges": "Save changes",
      "saving": "Saving..."
    },
    "loading": "Loading event data...",
    "previewLive": "Live preview",
    "previewPlatform": "Platform preview",
    "edit": "Edit",
    "step1": {
      "title": "The essentials of your event",
      "description": "Give your event an attractive title, an inspiring description, and choose its type.",
      "titleLabel": "Event title",
      "titlePlaceholder": "E.g. Biavent Networking Night Madrid",
      "titleHint": "Be clear and descriptive. A good title grabs your target audience instantly.",
      "visibilityLabel": "Public or private?",
      "visibilityPublic": "Public",
      "visibilityPrivate": "Private",
      "categoryLabel": "Main category",
      "eventTypeLabel": "Event type",
      "descriptionLabel": "Description",
      "descriptionPlaceholder": "Describe what attendees will learn, why your event is unique, and who it is for...",
      "highlightLabel": "Highlight quote",
      "highlightPlaceholder": "E.g. 'The biggest meetup for developers and investors of the year.'",
      "highlightHint": "A short, powerful phrase highlighted on the event landing page.",
      "tipTitle": "💡 Biavent tip",
      "tipText": "85% of registrations are driven by a structured description and a concise title. Define your target audience well!"
    },
    "step2": {
      "title": "Location and date",
      "description": "Set the date, time, and whether the event is in person or online.",
      "dateLabel": "Date",
      "timeLabel": "Time",
      "timePlaceholder": "E.g. 7:00 PM - 10:00 PM",
      "timezoneLabel": "Timezone",
      "locationLabel": "Location or link",
      "locationOnlineLabel": "Streaming link",
      "locationPlaceholder": "Street, city or link",
      "locationOnlinePlaceholder": "Zoom, Meet, YouTube...",
      "formatLabel": "Online or in person?",
      "formatInPerson": "In person",
      "formatOnline": "Online",
      "formatHybrid": "Hybrid",
      "mapButton": "Map",
      "venueLabel": "Venue name",
      "venuePlaceholder": "E.g. Main auditorium, Tech campus...",
      "arrivalLabel": "Additional arrival instructions",
      "arrivalPlaceholder": "Access, parking, floor, etc.",
      "mapsPreviewEmpty": "Enter an address to see the map preview",
      "capacityLabel": "Capacity limit",
      "capacityPlaceholder": "E.g. 100 — leave empty for unlimited",
      "capacityHint": "When capacity is reached, new registrations will be blocked automatically.",
      "latLabel": "Latitude (optional)",
      "lngLabel": "Longitude (optional)",
      "latPlaceholder": "E.g. 40.4167",
      "lngPlaceholder": "E.g. -3.7037"
    },
    "step3": {
      "title": "Your speakers",
      "description": "Introduce the speakers leading your sessions. Add role, bio, and photo.",
      "emptyTitle": "No speakers yet",
      "emptyText": "Will your event have speakers? Add them below. For informal networking you can skip this step.",
      "addSpeaker": "Add speaker",
      "nameLabel": "Name",
      "roleLabel": "Role",
      "bioLabel": "Short bio",
      "bioPlaceholder": "Short biography...",
      "avatarLabel": "Photo (URL)",
      "avatarPlaceholder": "https://...",
      "dragTitle": "Drag to reorder",
      "avatarUpload": "Upload photo",
      "avatarUploading": "Uploading...",
      "deleteSpeaker": "Remove"
    },
    "step4": {
      "title": "Program and agenda",
      "description": "Describe activities step by step so attendees can plan their day.",
      "emptyTitle": "Empty agenda",
      "emptyText": "Click «Add slot» to add activities (reception, talks, networking, etc.).",
      "addSlot": "Add slot",
      "startLabel": "Inizio",
      "endLabel": "Fine",
      "activityLabel": "Attività",
      "deleteSlot": "Rimuovi slot",
      "slotTitlePlaceholder": "Networking, talk...",
      "activityFallback": "Activity"
    },
    "step5": {
      "title": "Style and branding",
      "description": "Upload cover images, logos, and choose colors for cards and buttons.",
      "bannerLabel": "Cover / banner image",
      "bannerUpload": "Upload main image (1200×630)",
      "bannerUploading": "Uploading image...",
      "bannerRemove": "Remove cover",
      "bannerUrlHint": "Or paste an image URL:",
      "logoLabel": "Company / organizer logo",
      "logoUpload": "Upload logo",
      "logoUploading": "Uploading logo...",
      "logoRemove": "Remove logo",
      "logoUrlHint": "Or paste logo URL:",
      "typographyLabel": "Typography",
      "paletteLabel": "Event color palette",
      "paletteHint": "Pick a brand combination or customize the accent color.",
      "primaryColor": "Primary color",
      "accentColor": "Accent color (buttons)",
      "previewBadge": "UPCOMING",
      "previewCtaFallback": "Register"
    },
    "step6": {
      "title": "Review and publish",
      "description": "Add contact info, social links, and preview your landing before saving.",
      "websiteLabel": "Official website",
      "emailLabel": "Contact email",
      "mapsLabel": "Google Maps link",
      "socialLabel": "Social media (optional)",
      "ctaLabel": "Call-to-action button text",
      "ctaPlaceholder": "E.g. Register for the event",
      "ctaHint": "Text shown on the main registration button.",
      "reviewBasic": "Basics",
      "reviewLocation": "Location",
      "reviewSpeakers": "Speakers",
      "reviewAgenda": "Agenda",
      "reviewStyle": "Style",
      "noTitle": "No title",
      "toDefine": "To be defined",
      "speakersCount": "{{count}} speakers",
      "agendaCount": "{{count}} slots",
      "visualIdentity": "Visual identity",
      "withCover": "With cover",
      "withoutCover": "No cover"
    },
    "eventNew": {
      "title": "Create new event",
      "subtitle": "Follow the steps to publish on Biavent. It will be saved as a draft until you publish."
    },
    "errors": {
      "fixBeforeContinue": "Fix the errors before continuing to the next step.",
      "loadEvent": "Error loading event",
      "titleRequiredSave": "Please enter a title for your event",
      "fixStepBeforePublish": "Please fix the fields in Step {{step}} before publishing.",
      "invalidImage": "Please select a valid image file (png, jpg, jpeg)",
      "imageTooLarge": "Image size cannot exceed 5 MB",
      "uploadFailed": "Error uploading image",
      "draftUpdated": "Draft updated successfully",
      "eventUpdated": "Event updated successfully",
      "draftSaved": "Draft saved. You can edit and publish it later",
      "eventCreated": "Congratulations! The event was created successfully",
      "saveFailed": "Error saving"
    },
    "accordion": {
      "advancedLocation": "Advanced location",
      "capacity": "Capacity",
      "contact": "Contact and social (optional)"
    },
    "font": {
      "system": "System (default)",
      "serif": "Classic serif",
      "modern": "Modern sans"
    },
    "social": {
      "linkedinPlaceholder": "Your company LinkedIn URL",
      "twitterPlaceholder": "Twitter / X URL",
      "instagramPlaceholder": "Instagram URL"
    }
  },
  "dashboardPremium": {
    "greeting": "Welcome back, {name}",
    "contextSummary": "You have {events} events this week and {pending} pending to publish",
    "searchPlaceholder": "Search events…",
    "createEvent": "Create event",
    "viewAnalytics": "Analytics",
    "trendVsPrevious": "vs previous period",
    "kpiActiveEvents": "Active events",
    "kpiActiveEventsFooter": "{scheduled} scheduled · {live} live now",
    "kpiUsers": "Registered users",
    "kpiUsersFooter": "+{new} new this period",
    "kpiOrganizations": "Partner companies",
    "kpiOrgsFooter": "+{new} new this period",
    "kpiConversion": "Conversion",
    "kpiConversionFooter": "Registrations / users",
    "activityTitle": "Activity summary",
    "range7d": "7D",
    "range30d": "30D",
    "range90d": "90D",
    "seriesRegistrations": "Registrations",
    "seriesPublications": "Publications",
    "seriesConnections": "Connections",
    "chartEmpty": "No activity in this period yet",
    "upcomingTitle": "Upcoming events",
    "noUpcoming": "No upcoming events",
    "emptyUpcomingHint": "Crea un evento per vederlo qui una volta programmato.",
    "badgeLive": "LIVE",
    "badgeScheduled": "SCHEDULED",
    "badgeDraft": "DRAFT",
    "editEvent": "Edit",
    "viewAllUpcoming": "View all ({count}) →",
    "quickActionsTitle": "Quick actions",
    "performanceTitle": "Recent performance",
    "perfTopRegistrations": "Top registrations",
    "perfLowAttendance": "Lowest attendance",
    "perfTopOrgs": "Most active companies",
    "perfPendingTasks": "Pending tasks",
    "perfEmpty": "No data yet",
    "perfTasksEmpty": "No pending tasks",
    "taskDrafts": "{count} draft events",
    "taskUnpublished": "{count} upcoming drafts",
    "growthTitle": "Growth tips",
    "aiLabel": "AI recommendation",
    "growthTipDrafts": "Draft events don't generate registrations until you publish them.",
    "growthRecDrafts": "You have {count} draft(s). Publish at least one to start capturing attendees.",
    "growthTipCover": "Events with a professional cover image tend to convert better.",
    "growthRecCover": "Events with a cover image convert up to {percent}% better on average.",
    "growthTipAttendance": "Attendance is below your platform average.",
    "growthRecAttendance": "Current attendance rate is {rate}%. Send reminders before the event starts.",
    "growthTipDefault": "Keep publishing and engaging attendees after each event.",
    "growthRecDefault": "Review analytics after each event to double down on what works.",
    "feedTitle": "Recent activity",
    "feedEmpty": "No recent activity",
    "feedRegistration": "New registration",
    "feedPlatform": "Platform",
    "feedPublished": "Event published",
    "feedNewOrg": "New company",
    "loadError": "Could not load dashboard",
    "actionNewEventDesc": "Launch a new event in minutes",
    "actionNewOrgDesc": "Onboard a new partner company",
    "actionUsersDesc": "Manage users and roles",
    "actionPermissionsDesc": "Organizers and access",
    "actionNotificationsDesc": "Reach your audience",
    "actionAttendeesDesc": "Registrations and check-in",
    "actionAnalyticsDesc": "Networking and engagement",
    "actionExportDesc": "Export attendee data",
    "headerStatEventsWeek": "events this week",
    "headerStatPending": "pending to publish"
  },
  "notFound": {
    "title": "Pagina non trovata",
    "message": "La pagina che cerchi non esiste o non è più disponibile.",
    "goHome": "Vai agli eventi",
    "errorTitle": "Pagina non trovata",
    "errorMessage": "Non siamo riusciti a caricare questa vista.",
    "reload": "Ricarica app"
  },
  "meetingQr": {
    "confirmTitle": "Conferma incontro",
    "confirmWith": "Con {name}",
    "confirmCta": "Conferma incontro",
    "scanCta": "Scansiona QR",
    "scanTitle": "Scansiona QR incontro",
    "scanInstruction": "Inquadra il QR mostrato dall'altra persona.",
    "scanHint": "Chiedi all'altra persona di scansionare questo QR da Connessioni → Scansiona QR.",
    "generating": "Generazione QR sicuro…",
    "expiresIn": "Scade tra {time}",
    "confirmed": "Incontro confermato!",
    "expired": "Questo QR è scaduto",
    "generateAgain": "Genera nuovo QR",
    "verifying": "Verifica in corso…",
    "scanAgain": "Scansiona di nuovo",
    "back": "Indietro",
    "badgeConfirmed": "Incontro confermato",
    "errors": {
      "generic": "Qualcosa è andato storto. Riprova.",
      "invalid": "QR non valido",
      "expired": "Questo QR è scaduto",
      "alreadyUsed": "Questo QR è già stato usato",
      "notTarget": "Questo QR non è destinato a te",
      "self": "Non puoi confermare un incontro con te stesso",
      "noConnection": "Dovete prima essere connessi",
      "alreadyConfirmed": "Incontro già confermato",
      "noPriorChat": "Dovete avervi scritto prima",
      "rateLimited": "Troppi tentativi. Attendi un momento.",
      "camera": "Impossibile accedere alla fotocamera. Controlla i permessi.",
      "cameraDenied": "Permesso fotocamera negato",
      "cameraUnavailable": "Nessuna fotocamera trovata su questo dispositivo",
      "cameraInsecure": "La fotocamera richiede una connessione sicura (HTTPS)"
    },
    "cameraPermissionTitle": "Accesso alla fotocamera necessario",
    "cameraPermissionBody": "Per scansionare il QR dell’incontro, Biavent deve usare la fotocamera. Tocca il pulsante per consentire l’accesso.",
    "allowCamera": "Consenti fotocamera e scansiona",
    "requestingCamera": "Richiesta fotocamera…",
    "cameraDeniedHint": "L’accesso alla fotocamera è bloccato. Consenti la fotocamera a Biavent nelle impostazioni del browser o del telefono e riprova.",
    "tryAgain": "Riprova"
  }
}
